/*
    +919367788755
    8989829304
    +16308520397
    786-307-3615
*/
// eslint-disable-next-line no-useless-escape
export const phoneNumberRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/

export const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/

export const taxExemptRegex = /[0-9]{3}[-\s.]?[0-9]{3}[-\s.]?[0-9]{3}/
